/**
* @module @pakal/keys
* @copyright © 2018 Yisrael Eliav <yisraelx@gmail.com> (https://github.com/yisraelx)
* @license MIT
*/
var hasEnumBug = !({ toString: null }).propertyIsEnumerable('toString'), enumsBugProps = [
    'toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'
], hasOwnProperty = Object.prototype.hasOwnProperty;
function keys(object) {
    object = typeof object === 'string' ? object.split('') : object;
    var result = [];
    if (Object(object) !== object) {
        return result;
    }
    for (var key in object) {
        if (hasOwnProperty.call(object, key)) {
            result.push(key);
        }
    }
    if (hasEnumBug) {
        var index = enumsBugProps.length;
        while (--index >= 0) {
            var key = enumsBugProps[index];
            if (hasOwnProperty.call(object, key)) {
                result.push(key);
            }
        }
    }
    return result;
}

export default keys;
//# sourceMappingURL=index.esm.js.map
